import { createElement, PropTypes } from 'rlink-react';
import { ArticleComponent } from 'rlink-blog/component';

export default class ArticleLink extends ArticleComponent {
  render () {
    return (
      this.props.isDisabled
        ? <li className="arrow disabled">{this.props.text}</li>
        : (
          <li className="arrow ">
            <a href={this.href()}
              onClick={ev => {
                ev.persist();
                ev.preventDefault();
                this.props.onArticleNav(() => {
                  this.redirectToContent(ev, 'home');
                });
              }}
              className="ajax-processed">
              {this.props.text}
            </a>
          </li>
        )
    );
  }
}

ArticleLink.propTypes = {
  text: PropTypes.string,
  isDisabled: PropTypes.bool,
  onArticleNav: PropTypes.func,
};



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/News/ArticleLink.jsx